import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba1e263"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "waterfall" }
const _hoisted_2 = { class: "title-font" }
const _hoisted_3 = { class: "waterfall-item" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "image-title" }


import { defineComponent, defineProps } from 'vue'
import { getI18n } from '../utils'
const __default__ = defineComponent({
  name: 'ImageWaterFall'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String,
    require: true
  },
  imageList: {
    type: Object,
    require: true
  }
},
  setup(__props) {

// eslint-disable-next-line
const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.imageList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            span: 6,
            xs: 24,
            sm: 12,
            md: 8,
            lg: 6,
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: item.src,
                  class: "image-style"
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getI18n)(item.zhContent, item.enContent)), 1)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})